import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            热门爆料视频
          </h2>
          <p className="text-sm text-foreground-500">精选全网最火黑料视频，点击即可在线高清观看</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-accent-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl md:text-3xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-[10px] font-medium px-1.5 py-0.5 rounded bg-black/60 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}